<template>
  <div v-if="showview" class="rem">

    <div class="dialog flex-center">
      <div class="dialog-content bg-white radius-clip-5">
        <div class="dialog-content-tit flex-row-justify-space-between flex-row-align-center">
          <p class="dialog-content-tit-text font-size-20 font-color-1F233E">{{ bodyData[tipType].title }}</p>
          <div class="dialog-content-tit-close cursor flex-row-align-center" @click="dismiss">
            <p class="font-size-24 font-color-999 ">x</p>
          </div>
        </div>

        <div class="dialog-content-reason">
          <div class="dialog-content-reason-tit flex-row-align-center">
            <p class="font-size-14">原因</p>
          </div>
          <div v-if="datas" class="dialog-content-reason-radio flex">
            <div v-for="(item,idx) in datas" :key="idx" class="dialog-content-reason-radio-item flex flex-row-align-center">
              <el-radio v-model="radio" :label="item.dictKey" @change="reasonchange">{{ item.dictValue }}</el-radio>
            </div>
          </div>
        </div>
        <div v-if="showInput" class="dialog-content-input radius-clip-5">
          <textarea id="" class="font-size-12" name="" cols="30" :maxlength="maxlen" rows="10" :placeholder="bodyData[tipType].holder" @input="inputChange" />
          <div class="flex-row-align-center">
            <p class="font-size-12 ">{{ reqdel.length }}/</p>
            <p class="font-size-12 ">{{ maxlen }}</p>
          </div>
        </div>

        <div class="dialog-content-btns flex-row-align-center ">
          <div class="dialog-content-btns-cancel flex-center bg-F3F4F9 cursor radius-clip-5" @click="dismiss">
            <p class="font-size-14 font-color-264480">取消</p>
          </div>

          <div class="dialog-content-btns-ok flex-center bg-282B80 cursor radius-clip-5" @click="confirm">
            <p class="font-size-14 font-color-white">确定</p>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    maxlen: {
      type: Number,
      default: 20
    },
    datas: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      radio: 1,
      showview: false,
      reqdel: {
        length: 0,
        desc: '',
        id: null
      },
      showInput: false,
      bodyData: [{
        title: '删除理由',
        holder: '请输入删除理由，等待管理员删除'
      }, {
        title: '举报理由',
        holder: '请输入举报理由，等待管理员审核'
      }],
      tipType: 0
    }
  },
  methods: {
    show(type) {
      this.tipType = type || 0
      this.showview = true
      this.showInput = false
      this.radio = 1
      this.reqdel.desc = this.datas[0].dictValue
      this.reqdel.id = this.datas[0].dictKey
      this.reqdel.length = 0
    },
    dismiss() {
      this.showview = false
      this.showInput = false
    },
    confirm() {
      this.showview = false
      this.$emit('apply', this.reqdel)
    },
    inputChange(e) {
      this.reqdel.length = e.target.value.length
      this.reqdel.desc = e.target.value
    },
    reasonchange(e) {
      if (e === 8) {
        this.showInput = true
        this.reqdel.desc = ''
        this.reqdel.id = this.datas[e - 1].dictKey
      } else {
        this.showInput = false
        this.reqdel.desc = this.datas[e - 1].dictValue
        this.reqdel.id = this.datas[e - 1].dictKey
      }
      console.log(this.reqdel)
    }
  }
}
</script>
<style src="@/styles/pc.css" scoped>
</style>
<style lang="scss" scoped>
::v-deep .el-input__inner {
  font-size: 12px !important;
    color: #264480 !important;
    padding: 0 !important;
    border: none !important;
}
::v-deep .el-radio {
  display: flex;
}

</style>
<style scoped>

  .dialog {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 996;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .dialog-content {
    width: 540px;
    /* height: 290px; */
    padding: 30px;
  }

  .dialog-content-tit {
    height: 34px;
  }

  .dialog-content-tit-close {
    width: 34px;
    height: 34px;
    justify-content: flex-end;
  }

  .dialog-content-input {
    width: 100%;
    height: 110px;
    border: 1px solid rgba(189, 193, 208,0.5);
    margin-top: 24px;
    background: #F3F4F9;
    padding: 18px;
  }

  .dialog-content-input textarea {
    border: none;
    width: 100%;
    height: 60px;
    background: #F3F4F9;
    resize: none;
  }

  .dialog-content-input div {
    justify-content: flex-end;
  }

  .dialog-content-input textarea:focus{
    outline: none;
  }

  textarea::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #7B84A1;
    opacity: 0.5;
  }
  textarea:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #7B84A1;
    opacity: 0.5;
  }
  textarea::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #7B84A1;
    opacity: 0.5;
  }

  .dialog-content-btns {
    justify-content: flex-end;
    margin-top: 28px;
  }

  .dialog-content-btns>div {
    width: 82px;
    height: 30px;
  }

  .dialog-content-btns>div:first-child {
    margin-right: 18px;
  }

  .dialog-content-reason {
    margin-top: 15px;
  }

  .dialog-content-reason-tit {
    height: 34px;
  }

  .dialog-content-reason-radio  {
    flex-wrap: wrap;
  }

  .dialog-content-reason-radio-item {
    height: 34px;
    width: 25%;
  }

</style>
